var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.order
    ? _c("section", { staticClass: "bg-light py-4" }, [
        _c("div", { staticClass: "row mb-3" }, [
          _c(
            "div",
            { staticClass: "col-12 col-lg-8 offset-lg-2" },
            [
              _c(
                "router-link",
                {
                  staticClass: "text-primary-link",
                  attrs: {
                    to: _vm.isLineLoggedIn
                      ? "/line-liff/bookings"
                      : "/my-reservations"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("message.menu.my_reservations")))]
              ),
              _vm._v(" "),
              _c("i", { staticClass: "fal fa-angle-right" }),
              _vm._v(" "),
              _c(
                "router-link",
                {
                  staticClass: "text-primary-link",
                  attrs: { to: "/reservation/" + _vm.orderId }
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("message.my_reservations.reservation_detail"))
                  )
                ]
              ),
              _vm._v(" "),
              _c("i", { staticClass: "fal fa-angle-right" }),
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("message.my_reservations.payment")) +
                  "\n    "
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _vm.order.paid_status === 1
          ? _c("section", [
              _c("div", { staticClass: "row success-booking" }, [
                _c("div", { staticClass: "col-12 col-lg-8 offset-lg-2" }, [
                  _c("div", { staticClass: "text-center p-2 text-center" }, [
                    _c("i", {
                      staticClass: "fal fa-check-circle fa-5x -status-accepted"
                    }),
                    _vm._v(" "),
                    _c("h2", { staticClass: "pt-4 m-0" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm._f("currency")(
                              _vm.order.order_summary_total.total
                            )
                          ) +
                          "\n          "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "card" }, [
                    _c("div", { staticClass: "card-body" }, [
                      _c("div", [
                        _c("b", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("message.qr_payment.payment_successful")
                            )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _c("div", { staticClass: "row no-gutters pb-2" }, [
                        _c("div", { staticClass: "col-6" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.qr_payment.payment_method"))
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-6 text-right" }, [
                          _vm._v(
                            _vm._s(_vm.$t("message.payment_method.promptpay"))
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row no-gutters pb-2" }, [
                        _c("div", { staticClass: "col-6" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("message.qr_payment.transaction_date")
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-6 text-right" }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("prettyDate")(
                                _vm.order.order_summary_total.reconcile_date
                              )
                            )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row no-gutters" }, [
                        _c("div", { staticClass: "col-6" }, [
                          _vm._v(_vm._s(_vm.$t("message.qr_payment.order_id")))
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-6 text-right" }, [
                          _vm._v("#" + _vm._s(_vm.order.order_code))
                        ])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "pt-2" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "btn btn-info btn-block",
                          attrs: {
                            to: "/reservation/" + _vm.order.id,
                            tag: "a"
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t(
                                  "message.booking.complete_step.view_my_booking"
                                )
                              ) +
                              "\n          "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ])
              ])
            ])
          : _c("section", [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12 col-md-8 offset-md-2" }, [
                  _vm.globalState
                    ? _c("div", { staticClass: "card" }, [
                        _c("div", { staticClass: "card-body" }, [
                          _c("h3", { staticClass: "text-center py-2" }, [
                            _vm._v(
                              _vm._s(_vm.$t("message.bank_transfer.title"))
                            )
                          ]),
                          _vm._v(" "),
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$options.filters.bankTransferDurationText(
                                  _vm.order,
                                  _vm.globalState
                                )
                              )
                            }
                          }),
                          _vm._v(" "),
                          _vm.order.selected_professional_id > 0
                            ? _c("div", { staticClass: "mt-3" }, [
                                _c("img", {
                                  directives: [
                                    {
                                      name: "lazy",
                                      rawName: "v-lazy",
                                      value: _vm.order.professional_picture,
                                      expression: "order.professional_picture"
                                    }
                                  ],
                                  staticClass: "rounded-circle",
                                  attrs: { width: "40" }
                                }),
                                _vm._v(
                                  "\n               " +
                                    _vm._s(
                                      _vm._f("firstName")(
                                        _vm.order.professional_name
                                      )
                                    ) +
                                    "\n            "
                                )
                              ])
                            : _vm._e()
                        ])
                      ])
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12 col-md-8 offset-md-2" }, [
                  _c("div", { staticClass: "card" }, [
                    _c(
                      "div",
                      { staticClass: "card-body" },
                      [
                        _vm.order
                          ? [
                              _c(
                                "section",
                                { staticClass: "mt-3" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "text-left mt-4" },
                                    [
                                      _c("order-summary-detail", {
                                        attrs: { order: _vm.order }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("order-summary-total-short", {
                                    attrs: { order: _vm.order }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("hr")
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.order.paid_status === 0
                          ? _c("section", { staticClass: "mt-4" }, [
                              _c("div", { staticClass: "row" }, [
                                _c(
                                  "div",
                                  { staticClass: "col-12 text-center" },
                                  [
                                    _c("qr-code-payment", {
                                      ref: "qrCodePayment",
                                      on: { checkQrPayment: _vm.checkQrPayment }
                                    })
                                  ],
                                  1
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "row" }, [
                                _c("div", { staticClass: "col-12" }, [
                                  _c("hr"),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "text-remark" }, [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.$t(
                                            "message.promptpay.payment_remark"
                                          )
                                        ) +
                                        "\n                    "
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "pt-3 text-center" },
                                      [
                                        _c(
                                          "a",
                                          {
                                            staticClass:
                                              "btn btn-outline-info btn-block",
                                            attrs: {
                                              href:
                                                "https://line.me/R/ti/p/%40hnk7011n",
                                              target: "_blank"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                        " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "message.button.contact_admin"
                                                  )
                                                ) +
                                                "\n                      "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ])
                                ])
                              ])
                            ])
                          : _vm._e()
                      ],
                      2
                    )
                  ])
                ])
              ])
            ]),
        _vm._v(" "),
        _vm.isLineLoggedIn
          ? _c(
              "div",
              { staticClass: "container text-center pt-3 pb-4" },
              [
                _c(
                  "router-link",
                  { attrs: { to: "/reservation/" + _vm.order.id } },
                  [
                    _c("i", { staticClass: "fas fa-angle-left" }),
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("message.booking.new_booking.back")) +
                        "\n    "
                    )
                  ]
                )
              ],
              1
            )
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-48634235", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48634235","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/ConfirmPromptpay.vue
// module id = 1783
// module chunks = 0